<script setup>
import { computed, ref } from 'vue';
import InfoCard from '@/_company/components/InfoCard.vue';
import PageContent from '@/_company/components/PageContent.vue';
import { getPageBySlug } from '@/_company/helpers/contentful';

const contentBlocks = ref([]);
const pageContent = computed(() =>
  contentBlocks.value.find((block) => block.fields.contentType === 'Page Content'),
);
const infoCards = computed(() =>
  contentBlocks.value.filter((block) => block.fields.contentType === 'Info Card'),
);

const getEntries = async () => {
  const slug = 'certificates-empty';
  contentBlocks.value = await getPageBySlug(slug);
};

getEntries();
</script>

<template>
  <div>
    <div class="content-wrapper" v-if="pageContent">
      <PageContent class="page-content" v-if="pageContent" :fields="pageContent.fields" />
    </div>

    <div class="info-card-wrapper" v-if="infoCards">
      <InfoCard v-for="card in infoCards" :key="card.sys.id" :fields="card.fields" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.image {
  max-width: 160px;
}

.content-wrapper {
  background: $primary-background;
  box-shadow: $shadow-low-elevation;
  border-radius: $border-radius-x-small;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: $space-24;

  @include tablet-large {
    padding: 56px $space-24;
  }
}

.page-content {
  max-width: 512px;
}

.info-card-wrapper {
  @include desktop-small {
    display: flex;
  }
}
</style>
